/* ---- CC shared cart state (Sep 29 2026) ----------------------------------
 * The same block sits at the top of cc-fast-cart.js, cc-delivery.js and
 * cc-gift.js; whichever loads first installs it, the others reuse it.
 *   - ONE /cart.js download shared by every cart script (no duplicates).
 *   - Carts returned by /cart/change|update|clear are reused, not re-downloaded.
 *   - Any cart write marks the copy stale, so nobody ever reads an old cart.
 *   - preview(): the cart as the customer expects it right now (taps not yet
 *     saved). Used ONLY to repaint numbers instantly; never to act on.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.ccCart) { return; }
  var nf = window.fetch;
  if (!nf) { return; }
  var MUT = /\/cart\/(add|change|update|clear)/;
  var last = null, lastAt = 0, stale = true, pending = 0, ver = 0, inflight = null;
  var subs = [], psubs = [];

  function isCart(c) { return c && c.items && typeof c.total_price === 'number'; }
  function emit(list, c) { list.forEach(function (fn) { try { fn(c); } catch (e) {} }); }

  function set(c) {
    if (!isCart(c)) { return; }
    last = c; lastAt = Date.now();
    if (pending === 0) { stale = false; }
    emit(subs, c);
  }

  function get(maxAge) {
    if (!stale && pending === 0 && last && maxAge && Date.now() - lastAt < maxAge) {
      return Promise.resolve(last);
    }
    if (inflight) { return inflight; }
    var v = ver;
    inflight = nf.call(window, '/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inflight = null;
        if (v === ver && pending === 0) { set(c); }
        return c;
      }, function (e) { inflight = null; throw e; });
    return inflight;
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    var mut = MUT.test(url);
    if (mut) { ver++; pending++; stale = true; }
    var p = nf.apply(window, arguments);
    if (mut) {
      p.then(function (r) {
        pending = Math.max(0, pending - 1);
        if (!r.ok || /\/cart\/add/.test(url)) { stale = true; return; }
        var ct = (r.headers && r.headers.get('content-type')) || '';
        if (ct.indexOf('json') === -1) { stale = true; return; }
        r.clone().json().then(set).catch(function () { stale = true; });
      }, function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return p;
  };

  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && MUT.test(u)) {
      ver++; pending++; stale = true;
      this.addEventListener('loadend', function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return xo.apply(this, arguments);
  };

  window.ccCart = {
    get: get,
    last: function () { return last; },
    /* the cart only if it is known to be current (no write since it arrived) */
    fresh: function () { return (!stale && pending === 0) ? last : null; },
    on: function (fn) { subs.push(fn); },
    onPreview: function (fn) { psubs.push(fn); },
    preview: function (c) { if (isCart(c)) { emit(psubs, c); } }
  };
}());

/*  Classic Ceramics - delivery ladder nudge
 *
 *  ONE message in the cart, sitting directly above the Check out button:
 *  what delivery costs right now, then what to add to make it cheaper.
 *
 *  Tiers are read from the same data-ship-tiers attribute the advance
 *  payment popup uses, so there is ONE place to change the rates.
 *
 *  The "your total actually goes down" message is only shown when that is
 *  arithmetically true (the gap to the next tier is smaller than the saving).
 *  Claiming it otherwise would be a lie the customer can check.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('AdvanceNotice');
  if (!cfgEl) { return; }

  var RAW = cfgEl.getAttribute('data-ship-tiers') || '';
  var ACCENT = '#2f2f2f';

  /* ---- parse "0-3999:690;4000-7999:390;8000-14999:290;15000+:0" ---- */
  function parseTiers(str) {
    var out = [];
    String(str).split(';').forEach(function (chunk) {
      var bits = chunk.split(':');
      if (bits.length !== 2) { return; }
      var price = parseFloat(bits[1]);
      var range = bits[0].trim();
      var from;
      if (range.indexOf('+') > -1) {
        from = parseFloat(range.replace('+', ''));
      } else {
        from = parseFloat(range.split('-')[0]);
      }
      if (!isNaN(from) && !isNaN(price)) { out.push({ from: from, price: price }); }
    });
    out.sort(function (a, b) { return a.from - b.from; });
    return out;
  }

  var TIERS = parseTiers(RAW);
  if (TIERS.length < 2) { return; }

  function money(rupees) {
    return 'Rs ' + Math.round(rupees).toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Matches the theme's own money format, e.g. Rs.3,900.00, so the rows we
     add sit beside Subtotal without looking bolted on. */
  function siteMoney(rupees) {
    var n = (Math.round(rupees * 100) / 100).toFixed(2).split('.');
    return 'Rs.' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
  }

  function tierFor(total) {
    var found = TIERS[0];
    for (var i = 0; i < TIERS.length; i++) {
      if (total >= TIERS[i].from) { found = TIERS[i]; }
    }
    return found;
  }

  /* The next tier that is actually CHEAPER than the current one. */
  function nextCheaper(total) {
    var cur = tierFor(total);
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].from > total && TIERS[i].price < cur.price) { return TIERS[i]; }
    }
    return null;
  }

  function buildMessage(totalRupees) {
    var cur = tierFor(totalRupees);
    var nxt = nextCheaper(totalRupees);

    /* Nothing cheaper to reach: the Delivery row already states the charge
       (or FREE), so there is no message worth adding. */
    if (!nxt) { return null; }

    var gap = nxt.from - totalRupees;
    var saving = cur.price - nxt.price;
    var free = nxt.price === 0;
    var to = free ? '<b>FREE</b>' : '<b>' + money(nxt.price) + '</b>';
    var pct = Math.max(0, Math.min(100, (totalRupees / nxt.from) * 100));

    /* The charge itself is no longer repeated here - it now has its own
       Delivery row directly above, beside Subtotal. This box is the action. */
    if (gap < saving) {
      /* Adding the item makes the ORDER TOTAL fall. Only said when true. */
      return {
        tone: 'win',
        pct: pct,
        html: 'Add just <b>' + money(gap) + '</b> more and delivery drops to ' + to +
              ' &mdash; your total goes <b>DOWN by ' + money(saving - gap) + '</b>.'
      };
    }

    return {
      tone: 'near',
      pct: pct,
      html: 'Add <b>' + money(gap) + '</b> more and delivery drops to ' + to +
            ' &mdash; you save <b>' + money(saving) + '</b>.'
    };
  }

  /* ---------------- rendering ---------------- */

  var STYLE_ID = 'CCDeliveryStyle';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) { return; }
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.cc-deliv{margin:0 0 14px;padding:12px 14px;border:1px solid #e3e3e3;' +
      'border-left:3px solid ' + ACCENT + ';background:#f7f7f5;border-radius:3px;' +
      'font-size:13px;line-height:1.55;letter-spacing:.02em;text-align:left;color:#1c1c1c;}' +
      '.cc-deliv--win{background:#f0f6f0;border-left-color:#2e6b34;}' +
      '.cc-deliv--done{background:#f0f6f0;border-left-color:#2e6b34;}' +
      '.cc-deliv b{font-weight:700;}' +
      '.cc-deliv-bar{margin-top:9px;height:5px;border-radius:3px;background:#e2e2de;overflow:hidden;}' +
      '.cc-deliv-bar span{display:block;height:100%;background:' + ACCENT + ';' +
      'border-radius:3px;transition:width .35s ease;}' +
      '.cc-deliv--win .cc-deliv-bar span{background:#2e6b34;}';
    document.head.appendChild(s);
  }

  /* The box sits immediately ABOVE the Check out button, under the subtotal,
     because that is where the customer decides. The drawer has its own copy
     of .cart__checkout-wrapper, so each selector is scoped and every match is
     checked for visibility rather than taking the first one blindly. */
  var ANCHORS = [
    { sel: '.cart__page-col .cart__checkout-wrapper', mode: 'before' },
    { sel: '.drawer__footer .cart__checkout-wrapper', mode: 'before' },
    { sel: '.ajaxcart__subtotal', mode: 'before' },
    { sel: '.cart__page-col', mode: 'prepend' },
    { sel: '.drawer__scrollable', mode: 'prepend' }
  ];

  function placeIn(root) {
    for (var i = 0; i < ANCHORS.length; i++) {
      var all = root.querySelectorAll(ANCHORS[i].sel);
      for (var j = 0; j < all.length; j++) {
        if (all[j].offsetParent !== null) {
          return { el: all[j], mode: ANCHORS[i].mode };
        }
      }
    }
    return null;
  }

  /* The theme prints "Shipping, taxes, and discount codes calculated at
     checkout." under the button. Shipping is no longer unknown at this point,
     and two shipping messages on one screen is one too many. */
  function hideThemeNote() {
    var smalls = document.querySelectorAll('.cart__page-col small, .drawer__footer small');
    for (var i = 0; i < smalls.length; i++) {
      if (/calculated at checkout/i.test(smalls[i].textContent || '')) {
        var row = smalls[i].closest('.cart__item-row') || smalls[i];
        row.style.display = 'none';
      }
    }
  }

  /* A third-party app (Attrac) injects its own delivery bar into the cart
     carrying the OLD rates - "Delivery Rs 330 / Add Rs 13,650 more for FREE
     delivery". It lives in no theme file, so it cannot be corrected here and
     is hidden instead. Matched on its wording, never on our own box, and only
     inside the cart. If the app is later fixed or removed this simply finds
     nothing and does nothing. */
  var STALE = /for\s+free\s+delivery/i;
  var SCOPES = '.cart__page-col, .drawer__footer, .drawer__scrollable, .ajaxcart__subtotal';

  /* Throttled wrapper. The observer calls this on every DOM change so the
     app's bar is hidden in the same frame it appears rather than after a
     /cart.js round trip - that delay is what made it flash for a second or
     two before disappearing. */
  var lastHide = 0;
  function hideStaleBarsNow() {
    var t = Date.now();
    if (t - lastHide < 25) { return; }
    lastHide = t;
    hideStaleBars();
  }

  function hideStaleBars() {
    var scopes = document.querySelectorAll(SCOPES);
    for (var s = 0; s < scopes.length; s++) {
      var nodes = scopes[s].querySelectorAll('div, section, p, span, aside');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.closest('.cc-deliv') || el.querySelector('.cc-deliv')) { continue; }
        if (el.id === 'CCDelivRow' || el.id === 'CCTotalRow') { continue; }
        if (el.querySelector('#CCDelivRow, #CCTotalRow')) { continue; }
        var txt = el.textContent || '';
        if (txt.length > 160 || !STALE.test(txt)) { continue; }
        /* innermost match only, then climb to the card that wraps it */
        if (el.querySelector('div, p, span') &&
            STALE.test(el.querySelector('div, p, span').textContent || '')) { continue; }
        var target = el;
        for (var up = 0; up < 2; up++) {
          var p = target.parentElement;
          if (!p || p.querySelector('.cc-deliv') || (p.textContent || '').length > 200) { break; }
          if (/subtotal|check\s*out/i.test(p.textContent || '')) { break; }
          target = p;
        }
        target.style.display = 'none';
      }
    }
  }

  /* Shopify's Subtotal means goods before delivery, and that is what the
     checkout page will show. Overwriting it would make the cart and the
     checkout disagree, which is exactly how a COD customer loses trust.
     So Subtotal is left alone and two live rows are added beneath it. */
  var SUBTOTAL_SELECTORS =
    '.cart__page-col .cart__item-sub, .drawer__footer .cart__item-sub, .ajaxcart__subtotal';

  function totalsRow(id, label, value, strong) {
    var r = document.getElementById(id);
    if (!r) {
      r = document.createElement('div');
      r.id = id;
    }
    var w = strong ? ' style="font-weight:700;"' : '';
    r.innerHTML = '<div' + w + '>' + label + '</div><div' + w + '>' + value + '</div>';
    return r;
  }

  function upsertTotals(goods, ship) {
    var sub = null;
    var cands = document.querySelectorAll(SUBTOTAL_SELECTORS);
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      /* .cart__item-sub is ALSO the class on every line item's quantity row,
         so visibility alone is not enough - an earlier version attached these
         rows underneath the first product. The real totals row is the one
         that says "Subtotal" and is not inside a cart item. */
      if (c.offsetParent === null) { continue; }
      if (c.closest('.cart__item')) { continue; }
      if (!/subtotal/i.test(c.textContent || '')) { continue; }
      sub = c;
      break;
    }
    if (!sub || !sub.parentNode) { return; }

    var d = totalsRow('CCDelivRow', 'Delivery', ship === 0 ? 'FREE' : siteMoney(ship), false);
    var t = totalsRow('CCTotalRow', 'Order total', siteMoney(goods + ship), true);
    d.className = sub.className;
    t.className = sub.className;

    if (sub.nextSibling !== d) { sub.parentNode.insertBefore(d, sub.nextSibling); }
    if (d.nextSibling !== t) { d.parentNode.insertBefore(t, d.nextSibling); }
  }

  function render(totalRupees) {
    /* These four run on EVERY render, including carts that already have free
       delivery and therefore get no message. An earlier version returned
       before them, which left the stale app bar and the theme's shipping note
       on screen for exactly those customers. */
    injectStyle();
    upsertTotals(totalRupees, tierFor(totalRupees).price);
    hideThemeNote();
    hideStaleBars();

    var msg = buildMessage(totalRupees);
    var existing = document.querySelectorAll('.cc-deliv');
    if (!msg) {
      for (var k = 0; k < existing.length; k++) { existing[k].remove(); }
      return;
    }

    var spot = placeIn(document);
    if (!spot) {
      for (var j = 0; j < existing.length; j++) { existing[j].remove(); }
      return;
    }

    var box = document.querySelector('.cc-deliv');
    if (!box) {
      box = document.createElement('div');
      box.className = 'cc-deliv';
    }
    if (spot.mode === 'before') {
      if (box.nextSibling !== spot.el) { spot.el.parentNode.insertBefore(box, spot.el); }
    } else if (box.parentNode !== spot.el) {
      spot.el.insertBefore(box, spot.el.firstChild);
    }

    box.className = 'cc-deliv cc-deliv--' + msg.tone;
    var bar = msg.pct === undefined ? '' :
      '<div class="cc-deliv-bar"><span style="width:' + msg.pct.toFixed(1) + '%"></span></div>';
    box.innerHTML = msg.html + bar;
  }

  /* ---------------- cart watching ---------------- */

  var lastTotal = -1;
  var busy = false;

  /* The theme redraws the drawer from scratch, which wipes our rows even
     when the total has not changed - so "same total" is not enough. */
  function rowsMissing() {
    var r = document.getElementById('CCTotalRow');
    return !r || r.offsetParent === null;
  }

  /* Sep 29: repaint straight from the shared cart state - on the tap
     (preview) and the moment Shopify answers - with no extra download. */
  /* Sep 30: an empty cart gets no Delivery / Order total rows and no
     message (it used to show "Order total Rs 330" on an empty cart). */
  function clearAll() {
    var els = document.querySelectorAll('.cc-deliv, #CCDelivRow, #CCTotalRow');
    for (var i = 0; i < els.length; i++) { els[i].remove(); }
    lastTotal = -1;
  }
  function paintFrom(c) {
    if (!c || typeof c.total_price !== 'number') { return; }
    if (c.item_count === 0) { clearAll(); return; }
    if (!placeIn(document)) { return; }
    var rupees = (c.total_price || 0) / 100;
    if (rupees !== lastTotal || rowsMissing()) { lastTotal = rupees; render(rupees); }
  }
  /* Sep 30: while a tap is still being saved, paint from the cart the
     customer EXPECTS (pv) - the background refresh used to put the old
     total back for a moment before Shopify answered. */
  var pv = null, pvAt = 0;
  function livePv() { return pv && Date.now() - pvAt < 8000 ? pv : null; }
  if (window.ccCart) {
    window.ccCart.on(function (c) { pv = null; paintFrom(c); });
    window.ccCart.onPreview(function (c) { pv = c; pvAt = Date.now(); paintFrom(c); });
  }

  function refresh(force, maxAge) {
    if (busy) { return; }
    if (!placeIn(document)) {
      var old = document.querySelectorAll('.cc-deliv');
      for (var i = 0; i < old.length; i++) { old[i].remove(); }
      return;
    }
    busy = true;
    var load = window.ccCart ? window.ccCart.get(force ? 0 : (maxAge || 3000)) :
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    load
      .then(function (c) {
        c = livePv() || c;
        if (c.item_count === 0) { clearAll(); return; }
        var rupees = (c.total_price || 0) / 100;
        if (force || rupees !== lastTotal || rowsMissing()) {
          lastTotal = rupees;
          render(rupees);
        } else {
          hideStaleBars();
        }
      })
      .catch(function () { /* leave the cart alone if this fails */ })
      .then(function () { busy = false; });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(false); }, 350);
  }

  function boot() {
    /* Hide first, ask questions later: the app's bar may already be on the
       page, and waiting for the cart fetch is what the customer sees as a
       flash of the wrong price. */
    hideStaleBars();
    refresh(true);

    /* Apps inject late and on their own schedule, so sweep briskly for the
       first few seconds of the page's life, then stop. */
    var sweeps = 0;
    var sweeper = setInterval(function () {
      hideStaleBars();
      if (++sweeps > 24) { clearInterval(sweeper); }
    }, 250);

    var obs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && t.closest('.cc-deliv')) { continue; }
        hideStaleBarsNow();
        /* Sep 29: the drawer was just redrawn and our rows are gone - put
           them back in this same frame if the current cart is already known. */
        var fc = livePv() || (window.ccCart && window.ccCart.fresh && window.ccCart.fresh());
        if (fc && (rowsMissing() || fc.item_count === 0)) { paintFrom(fc); }
        schedule();
        return;
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { refresh(true); });
    window.addEventListener('pageshow', function () { refresh(true); });

    /* Safety net. The observer catches any cart change that redraws the DOM,
       which covers the quantity buttons and the drawer. But these rows now
       show PRICES, and a stale price is worse than a late one - so the cart
       is also re-read every few seconds while a cart is actually on screen.
       refresh() no-ops when the total has not moved, and stops entirely when
       the customer is not looking at a cart. */
    setInterval(function () {
      if (document.hidden) { return; }
      /* Sep 29: every cart write already updates the shared cart, so this
         safety net reuses a copy up to 15 s old instead of downloading
         the cart every 4 s. */
      refresh(false, 15000);
    }, 4000);

    /* ...and the moment the customer comes back to the tab, since the poll
       above deliberately does nothing while it is in the background. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { refresh(true); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
